import { BankOutlined, TeamOutlined } from '@ant-design/icons'
import {
  Badge,
  Button,
  DatePicker,
  Dropdown,
  Form,
  Select,
  Space,
  Tag,
  Tooltip,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import qs from 'qs'
import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { yellowPrimary } from '../../color'
import { Tuning2OutlineIcon } from '../../components/AppIcon'
import { AvatarHasName } from '../../components/Common/Avatar'
import EmptyContent from '../../components/EmptyContent'
import SelectGroupPopup from '../../components/SelectGroupPopup/SelectGroupPopup'
import { ASSIGNEE_TYPE, ISO_DATE_FORMAT, MM_YYYY } from '../../constants'
import { TaskRequest } from '../../requests/TaskRequest'
import { checkValidFormFieldValue } from '../../utils/helper'
import { SelectList } from '../MissionCreatePage/MissionCreatePageStyled'

const { Option } = Select

const MissionAdvanderFilterV2 = props => {
  const {
    taskStore,
    taskLevelList,
    authenticationStore,
    dispatchUserFilter,
    selectPeopleStore,
    isVisibleCreateMissionPopup,
    countFilter,
  } = props

  const [showFilter, setShowFilter] = useState(false)
  const [form] = Form.useForm()

  const location = useLocation()
  const history = useHistory()
  const queryStringParse = useMemo(
    () => qs.parse(location.search.replace('?', '')),
    [location.search]
  )

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    setIsVisibleSelectUserDepartmentPopup,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
  } = selectPeopleStore

  const { missionQueryParams } = taskStore
  const { currentUser } = authenticationStore

  const [leaderList, setLeaderList] = useState([])
  const [handlerList, setHandlerList] = useState([])
  const [combinerList, setCombinerList] = useState([])

  useEffect(() => {
    setLeaderList([
      ...selectUserData[ASSIGNEE_TYPE.LEADER],
      ...selectDepartmentData[ASSIGNEE_TYPE.LEADER],
      ...selectGroupData[ASSIGNEE_TYPE.LEADER],
    ])
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setCombinerList([
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  useEffect(() => {
    if (showFilter) {
      form.setFieldsValue({
        tien_do: queryStringParse.tien_do || undefined,
        id_task_level: queryStringParse.id_task_level || undefined,
        tag: queryStringParse?.tag || undefined,
        date_by: queryStringParse.date_by || 'DISPLAY_DATE',
        month: !queryStringParse.all_time
          ? queryStringParse.from_date
            ? moment(String(queryStringParse.from_date))
            : moment()
          : null,
      })
    }
  }, [showFilter, queryStringParse, form])

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const handleSubmitSelect = () => {
    setIsVisibleSelectGroupPopup(false)
    setIsVisibleSelectUserDepartmentPopup(false)
  }

  const [tagList, setTagList] = useState([])

  const handleGetMissionTaskType = async () => {
    await TaskRequest.getTagList().then(res => {
      setTagList(
        res.data.map(tag => ({
          code: tag.code,
          name: tag.name,
          type: tag.type,
        }))
      )
    })
  }

  useEffect(() => {
    handleGetMissionTaskType()
  }, [])

  const onFinish = values => {
    const params = {
      tien_do: values.tien_do || null,
      id_task_level: values.id_task_level || null,
      tag: values.tag || null,
      date_by: values.date_by || 'DISPLAY_DATE',
    }

    if (values.month) {
      params.from_date = values.month.startOf('month').format(ISO_DATE_FORMAT)
      params.to_date = values.month.endOf('month').format(ISO_DATE_FORMAT)
      params.all_time = null
    } else {
      params.from_date = null
      params.to_date = null
      params.all_time = 1
    }

    taskStore.setMissionQueryParams({
      ...missionQueryParams,
      ...params,
    })
    console.log(missionQueryParams, 'params', params)

    const applyAssignee = type => {
      if (selectGroupData[type]?.length > 0) {
        dispatchUserFilter({
          type: type,
          value: selectGroupData[type][0].id,
          fullName: selectGroupData[type][0].full_name,
          assigneeType: ASSIGNEE_TYPE.GROUP,
        })
      } else if (selectUserData[type]?.length > 0) {
        dispatchUserFilter({
          type: type,
          value: selectUserData[type][0].id,
          fullName: selectUserData[type][0].full_name,
          assigneeType: ASSIGNEE_TYPE.USER,
        })
      } else if (selectDepartmentData[type]?.length > 0) {
        dispatchUserFilter({
          type: type,
          value: selectDepartmentData[type][0].id,
          fullName: selectDepartmentData[type][0].full_name,
          assigneeType: ASSIGNEE_TYPE.DEPARTMENT,
        })
      } else {
        dispatchUserFilter({
          type: type,
          value: null,
          fullName: null,
          assigneeType: ASSIGNEE_TYPE.USER,
        })
      }
    }

    const queryStringStringify = qs.stringify(
      {
        ...queryStringParse,
        ...params,
      },
      {
        skipNulls: true,
        arrayFormat: 'indices',
      }
    )
    setTimeout(() => {
      applyAssignee(ASSIGNEE_TYPE.LEADER)
      applyAssignee(ASSIGNEE_TYPE.HANDLER)
      applyAssignee(ASSIGNEE_TYPE.COMBINER)
    }, 10)
    history.replace(`/mission?${queryStringStringify}`)

    onToggleFilter()
  }

  const values = Form.useWatch([], form)
  const hasFormValue =
    Object.values(values || {}).some(checkValidFormFieldValue) ||
    leaderList.length > 0 ||
    handlerList.length > 0 ||
    combinerList.length > 0

  console.log(leaderList, handlerList, combinerList)

  return (
    <Dropdown
      overlayStyle={{
        zIndex: 200,
      }}
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div
          className="custom-page-filter-dropdown-container"
          style={{ width: 400 }}>
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item name="date_by" label="Lọc theo">
                <Select style={{ width: '100%' }} className="h-40">
                  <Option value="DISPLAY_DATE">Lọc theo Tháng hiển thị</Option>
                  <Option value="CREATED_DATE">Lọc theo Ngày tạo</Option>
                </Select>
              </Form.Item>
              <Form.Item name="month" label="Tháng">
                <DatePicker
                  className="h-40"
                  picker="month"
                  placeholder="Chọn tháng"
                  format={MM_YYYY}
                  style={{ width: '100%' }}
                />
              </Form.Item>

              <Form.Item
                name="tien_do"
                style={{ marginBottom: 16 }}
                label="Tiến độ">
                <Select
                  className="h-40"
                  placeholder={'Lọc theo tiến độ'}
                  allowClear
                  style={{ width: '100%' }}>
                  <Option value="001">Hoàn thành</Option>
                  <Option value="002">Chưa hoàn thành</Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="id_task_level"
                style={{ marginBottom: 16 }}
                label="Cấp giao nhiệm vụ">
                <Select
                  className="h-40"
                  style={{ width: '100%' }}
                  notFoundContent={<EmptyContent />}
                  placeholder={'Chọn cấp giao nhiệm vụ'}
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option?.props?.children
                      .toLowerCase()
                      .indexOf(input?.toLowerCase()) >= 0 ||
                    option?.props?.value
                      .toLowerCase()
                      .indexOf(input?.toLowerCase()) >= 0
                  }>
                  {taskLevelList?.map(taskLevel => (
                    <Option key={taskLevel.id_level} value={taskLevel.id_level}>
                      {taskLevel.ten_cap}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="tag"
                style={{ marginBottom: 16 }}
                label="Loại nhiệm vụ">
                <Select
                  mode="multiple"
                  showSearch
                  allowClear
                  showArrow
                  notFoundContent={<EmptyContent />}
                  style={{ width: '100%' }}
                  placeholder="Chọn loại nhiệm vụ"
                  value={props.value}>
                  {tagList.map(tag => (
                    <Option name={tag.name} value={tag.code} key={tag.code}>
                      {tag.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <div
                style={{
                  marginBottom: 8,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}>
                <span>Lãnh đạo giao việc:</span>
                <Space>
                  <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                    <Button
                      className="select-user-icon-btn"
                      icon={<TeamOutlined />}
                      style={{ color: yellowPrimary }}
                      onClick={() => {
                        setIsVisibleSelectGroupPopup(true)
                        handleOpenSelectGroupPopup(ASSIGNEE_TYPE.LEADER)
                      }}
                    />
                  </Tooltip>
                </Space>
              </div>
              <SelectList>
                {leaderList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => {
                      dispatchUserFilter({
                        type: el.permission,
                        value: null,
                        fullName: null,
                        assigneeType: null,
                      })
                      selectPeopleStore.handleRemoveSelect(el)
                    }}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
              <div style={{ height: 16 }} />

              {(queryStringParse.PIC || queryStringParse.COOR) ===
              currentUser?.username ? null : (
                <>
                  <div
                    style={{
                      marginBottom: 8,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}>
                    <span>Xử lý chính:</span>
                    <Space>
                      <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                        <Button
                          className="select-user-icon-btn"
                          icon={<TeamOutlined />}
                          style={{ color: yellowPrimary }}
                          onClick={() => {
                            setIsVisibleSelectGroupPopup(true)
                            handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
                          }}
                        />
                      </Tooltip>
                    </Space>
                  </div>
                  <SelectList>
                    {handlerList.map(el => (
                      <Tag
                        className={'tag-selected'}
                        color={'blue'}
                        key={el.id}
                        closable
                        onClose={() => {
                          dispatchUserFilter({
                            type: el.permission,
                            value: null,
                            fullName: null,
                            assigneeType: null,
                          })
                          selectPeopleStore.handleRemoveSelect(el)
                        }}>
                        <AvatarHasName
                          imgId={el.image_id}
                          size={22}
                          name={el.full_name}
                          icon={
                            (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                              <BankOutlined />
                            )) ||
                            (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                              <TeamOutlined />
                            ))
                          }
                        />
                      </Tag>
                    ))}
                  </SelectList>
                  <div style={{ height: 16 }} />
                  <div
                    style={{
                      marginBottom: 8,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}>
                    <span>Phối hợp xử lý:</span>
                    <Space>
                      <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                        <Button
                          className="select-user-icon-btn"
                          icon={<TeamOutlined />}
                          style={{ color: yellowPrimary }}
                          onClick={() => {
                            setIsVisibleSelectGroupPopup(true)
                            handleOpenSelectGroupPopup(ASSIGNEE_TYPE.COMBINER)
                          }}
                        />
                      </Tooltip>
                    </Space>
                  </div>
                  <SelectList>
                    {combinerList?.map(el => (
                      <Tag
                        className={'tag-selected'}
                        color={'blue'}
                        key={el?.id}
                        closable
                        onClose={() => {
                          dispatchUserFilter({
                            type: el?.permission,
                            value: null,
                            fullName: null,
                            assigneeType: null,
                          })
                          selectPeopleStore.handleRemoveSelect(el)
                        }}>
                        <AvatarHasName
                          imgId={el?.image_id}
                          size={22}
                          name={el?.full_name}
                          icon={
                            (el?.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                              <BankOutlined />
                            )) ||
                            (el?.assignee_type === ASSIGNEE_TYPE.GROUP && (
                              <TeamOutlined />
                            ))
                          }
                        />
                      </Tag>
                    ))}
                  </SelectList>
                </>
              )}
            </div>
            <div style={{ height: 16 }} />
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()

                  const removeAllFromStore = list => {
                    list.forEach(el => selectPeopleStore.handleRemoveSelect(el))
                  }
                  removeAllFromStore(leaderList)
                  removeAllFromStore(handlerList)
                  removeAllFromStore(combinerList)

                  const params = {
                    tien_do: null,
                    id_task_level: null,
                    tag: null,
                    date_by: 'DISPLAY_DATE',
                    from_date: moment()
                      .startOf('month')
                      .format(ISO_DATE_FORMAT),
                    to_date: moment().endOf('month').format(ISO_DATE_FORMAT),
                    all_time: null,
                  }
                  taskStore.setMissionQueryParams({
                    ...missionQueryParams,
                    ...params,
                  })
                  const queryStringStringify = qs.stringify(
                    { ...queryStringParse, ...params },
                    { skipNulls: true, arrayFormat: 'indices' }
                  )
                  setTimeout(() => {
                    dispatchUserFilter({
                      type: ASSIGNEE_TYPE.LEADER,
                      value: null,
                      fullName: null,
                    })
                    dispatchUserFilter({
                      type: ASSIGNEE_TYPE.HANDLER,
                      value: null,
                      fullName: null,
                    })
                    dispatchUserFilter({
                      type: ASSIGNEE_TYPE.COMBINER,
                      value: null,
                      fullName: null,
                    })
                  }, 10)
                  history.replace(`/mission?${queryStringStringify}`)

                  onToggleFilter()
                }}>
                Xóa
              </Button>
            </div>
          </Form>

          <SelectGroupPopup
            onlySelectOne
            groupType={'nhiem_vu'}
            isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
            handleCancelSelectGroup={handleCancelSelectGroup}
            handleSubmitSelectGroup={handleSubmitSelect}
          />
        </div>
      )}
      placement="bottomRight">
      <Badge count={countFilter || 0} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

export default inject(
  'taskStore',
  'departmentStore',
  'loadingAnimationStore',
  'authenticationStore',
  'selectPeopleStore'
)(observer(MissionAdvanderFilterV2))
